import { type PropsWithChildren } from 'react';

import type { LegendProps } from '../types/chart-layout.js';

/**
 * Legend wrapper legend-area component.
 */
export const Legend = ({ children }: PropsWithChildren<LegendProps>) => (
  // oxlint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);

Legend['displayName'] = 'LegendWrapper.Legend';
